<template>
    <el-card class="box-card origin-realm-champion">
        <section class="content">
            <el-card>
                <el-form :inline="true" label-suffix=":">
                    <el-form-item label='赛季'>
                        <el-select v-model="recordByRealmSeasonForm.realmSeason" placeholder='选择赛季'>
                            <el-option v-for="item in originRealmSeasonOptions" :key="item.id" :label="item.id + '-' + $t(item.name)" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='筛选'>
                        <el-select v-model="championOptionsSelect" clearable>
                            <el-option v-for="item in championOptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!--<el-form-item label="只看冠军">-->
                        <!--<el-switch-->
                            <!--v-model="isSelectChampion"-->
                            <!--active-color="#13ce66"-->
                            <!--inactive-color="#ff4949"-->
                            <!--:active-value="true"-->
                            <!--:inactive-value="false">-->
                        <!--</el-switch>-->
                    <!--</el-form-item>-->
                    <el-form-item>
                        <el-button  type="primary" @click="recordByRealmSeason">查询</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button  type="primary" @click="sortRecords">刷新排序</el-button>
                    </el-form-item>
                </el-form>
            </el-card>

            <el-tabs style="margin: 20px 0" v-model="allChampionActiveName" type="border-card">
                <el-tab-pane name="first" label="官方战区">
                    <el-table :data="allChampionRecord1" class="table-champion-record" :header-cell-style="headerCellStyle" :cell-style="{'text-align':'center','border-bottom':'none','font-weight':'bold','padding':'unset'}">
                        <el-table-column :label="langSelect=='cn'?'最终名次':langSelect=='hant'?'最終名次':langSelect=='en'?'Final Rank':''" :width="langSelect=='en'?'105':'96'">
                            <template slot-scope="scope">
                                <div class="nick-text" v-for="item in rankingOptions" v-if="item.value == scope.row.ranking && scope.row.ranking!==70001">{{langSelect=='cn'?item.label:langSelect=='hant'?item.hant:langSelect=='en'?item.en:''}}</div>
                                <div v-for="item in rankingOptions" v-if="item.value == scope.row.ranking && scope.row.ranking==70001">
                                    <img v-if="langSelect=='cn'" src="../../assets/champion.png" alt="" class="champion-img">
                                    <img v-if="langSelect=='hant'" src="../../assets/champion-hant.png" alt="" class="champion-img">
                                    <img v-if="langSelect=='en'" src="../../assets/champion-en.png" alt="" class="champion-img-en">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="langSelect=='cn'?'探索者信息':langSelect=='hant'?'探索者資訊':langSelect=='en'?'Explorer Info':''" :width="flexColumnWidth('Explorer Info','nick',allChampionRecord1)">
                            <template slot-scope="scope">
                                <div class="nick-text">{{scope.row.nick}}</div>
                                <div class="nick-text" v-for="item in loginInfoGameOptions" v-if="item.server_number == scope.row.gameServer">「{{$t(item.server_name)}}」</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="lineupIdentifierInfo" :label="langSelect=='cn'?'源初境阵容':langSelect=='hant'?'源初境陣容':langSelect=='en'?'Sanctum Lineup':''" width="540">
                            <template slot-scope="scope">
                                <div style="display: flex;justify-content: center;align-items: center;">
                                    <div class="img-container" v-for="item in scope.row.lineupIdentifierInfo.split(',').reverse()">
                                        <img class="prop-img" :src="'../../../static/monster_bg_frame/monster_icon_bg_p' + (monsterItem.quality+1) +'.png'" alt="" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">
                                        <el-image class="prop-img"
                                                  :src="'./static/monster_icon/'+ item +'.png'"
                                                  fit="cover">
                                        </el-image>
                                        <img class="prop-img-box" :src="'../../../static/monster_bg_frame/icon_monster_frame_' + (monsterItem.quality+2) +'.png'" alt="" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">
                                        <div class="monster-name" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">{{$t(monsterItem.name)}}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="second" label="渠道战区">
                    <el-table :data="allChampionRecord2" class="table-champion-record" :header-cell-style="headerCellStyle" :cell-style="{'text-align':'center','border-bottom':'none','font-weight':'bold','padding':'unset'}">
                        <el-table-column :label="langSelect=='cn'?'最终名次':langSelect=='hant'?'最終名次':langSelect=='en'?'Final Rank':''" :width="langSelect=='en'?'105':'96'">
                            <template slot-scope="scope">
                                <div class="nick-text" v-for="item in rankingOptions" v-if="item.value == scope.row.ranking && scope.row.ranking!==70001">{{langSelect=='cn'?item.label:langSelect=='hant'?item.hant:langSelect=='en'?item.en:''}}</div>
                                <div v-for="item in rankingOptions" v-if="item.value == scope.row.ranking && scope.row.ranking==70001">
                                    <img v-if="langSelect=='cn'" src="../../assets/champion.png" alt="" class="champion-img">
                                    <img v-if="langSelect=='hant'" src="../../assets/champion-hant.png" alt="" class="champion-img">
                                    <img v-if="langSelect=='en'" src="../../assets/champion-en.png" alt="" class="champion-img-en">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="langSelect=='cn'?'探索者信息':langSelect=='hant'?'探索者資訊':langSelect=='en'?'Explorer Info':''" :width="flexColumnWidth('Explorer Info','nick',allChampionRecord2)">
                            <template slot-scope="scope">
                                <div class="nick-text">{{scope.row.nick}}</div>
                                <div class="nick-text" v-for="item in loginInfoGameOptions" v-if="item.server_number == scope.row.gameServer">「{{$t(item.server_name)}}」</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="lineupIdentifierInfo" :label="langSelect=='cn'?'源初境阵容':langSelect=='hant'?'源初境陣容':langSelect=='en'?'Sanctum Lineup':''" width="540">
                            <template slot-scope="scope">
                                <div style="display: flex;justify-content: center;align-items: center;">
                                    <div class="img-container" v-for="item in scope.row.lineupIdentifierInfo.split(',').reverse()">
                                        <img class="prop-img" :src="'../../../static/monster_bg_frame/monster_icon_bg_p' + (monsterItem.quality+1) +'.png'" alt="" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">
                                        <el-image class="prop-img"
                                                  :src="'./static/monster_icon/'+ item +'.png'"
                                                  fit="cover">
                                        </el-image>
                                        <img class="prop-img-box" :src="'../../../static/monster_bg_frame/icon_monster_frame_' + (monsterItem.quality+2) +'.png'" alt="" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">
                                        <div class="monster-name" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">{{$t(monsterItem.name)}}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="third" label="互通战区">
                    <el-table :data="allChampionRecord3" class="table-champion-record" :header-cell-style="headerCellStyle" :cell-style="{'text-align':'center','border-bottom':'none','font-weight':'bold','padding':'unset'}">
                        <el-table-column :label="langSelect=='cn'?'最终名次':langSelect=='hant'?'最終名次':langSelect=='en'?'Final Rank':''" :width="langSelect=='en'?'105':'96'">
                            <template slot-scope="scope">
                                <div class="nick-text" v-for="item in rankingOptions" v-if="item.value == scope.row.ranking && scope.row.ranking!==70001">{{langSelect=='cn'?item.label:langSelect=='hant'?item.hant:langSelect=='en'?item.en:''}}</div>
                                <div v-for="item in rankingOptions" v-if="item.value == scope.row.ranking && scope.row.ranking==70001">
                                    <img v-if="langSelect=='cn'" src="../../assets/champion.png" alt="" class="champion-img">
                                    <img v-if="langSelect=='hant'" src="../../assets/champion-hant.png" alt="" class="champion-img">
                                    <img v-if="langSelect=='en'" src="../../assets/champion-en.png" alt="" class="champion-img-en">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="langSelect=='cn'?'探索者信息':langSelect=='hant'?'探索者資訊':langSelect=='en'?'Explorer Info':''" :width="flexColumnWidth('Explorer Info','nick',allChampionRecord3)">
                            <template slot-scope="scope">
                                <div class="nick-text">{{scope.row.nick}}</div>
                                <div class="nick-text" v-for="item in loginInfoGameOptions" v-if="item.server_number == scope.row.gameServer">「{{$t(item.server_name)}}」</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="lineupIdentifierInfo" :label="langSelect=='cn'?'源初境阵容':langSelect=='hant'?'源初境陣容':langSelect=='en'?'Sanctum Lineup':''" width="540">
                            <template slot-scope="scope">
                                <div style="display: flex;justify-content: center;align-items: center;">
                                    <div class="img-container" v-for="item in scope.row.lineupIdentifierInfo.split(',').reverse()">
                                        <img class="prop-img" :src="'../../../static/monster_bg_frame/monster_icon_bg_p' + (monsterItem.quality+1) +'.png'" alt="" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">
                                        <el-image class="prop-img"
                                                  :src="'./static/monster_icon/'+ item +'.png'"
                                                  fit="cover">
                                        </el-image>
                                        <img class="prop-img-box" :src="'../../../static/monster_bg_frame/icon_monster_frame_' + (monsterItem.quality+2) +'.png'" alt="" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">
                                        <div class="monster-name" v-for="monsterItem in monsterConfig" v-if="item == monsterItem.id">{{$t(monsterItem.name)}}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </section>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import langConfApi from '../../service/lang_conf_api'
    import confApi from '../../service/conf_api'
    import utils from '../../lib/utils'

    export default {
        name: "origin_realm_champion",
        data () {
            return {
                allChampionRecordForm: {
                    realmSeason: ''
                },
                originRealmSeasonOptions: [],
                allChampionRecord: [],
                allChampionRecord1: [],
                allChampionRecord2: [],
                allChampionRecord3: [],
                loginInfoGameOptions: [],
                monsterConfig: [],

                recordByRealmSeasonForm: {
                    worldUri: '',
                    realmSeason: ''
                },

                // 只看冠军
                isSelectChampion: false,

                allChampionActiveName: 'first',

                rankingOptions: [
                    {
                        value: 40001,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 40002,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 40003,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 40004,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 40005,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 40006,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 40007,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 40008,
                        label: '八强',
                        hant: '八強',
                        en: 'Top 8'
                    },
                    {
                        value: 50001,
                        label: '四强',
                        hant: '四強',
                        en: 'Top 4'
                    },
                    {
                        value: 50002,
                        label: '四强',
                        hant: '四強',
                        en: 'Top 4'
                    },
                    {
                        value: 50003,
                        label: '四强',
                        hant: '四強',
                        en: 'Top 4'
                    },
                    {
                        value: 50004,
                        label: '四强',
                        hant: '四強',
                        en: 'Top 4'
                    },
                    {
                        value: 60001,
                        label: '亚军',
                        hant: '亞軍',
                        en: 'Runner-up'
                    },
                    {
                        value: 60002,
                        label: '亚军',
                        hant: '亞軍',
                        en: 'Runner-up'
                    },
                    {
                        value: 70001,
                        label: '冠军',
                        hant: '冠軍',
                        en: 'Champion'
                    },
                ],
                championOptions: [
                    {
                        value: 1,
                        label: '冠军'
                    },
                    {
                        value: 2,
                        label: '四强'
                    },
                    {
                        value: 3,
                        label: '八强'
                    },
                ],
                championOptionsSelect: '',

                langSelect: 'cn'
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList
            }),
        },
        mounted() {
        },
        created() {
            this.getReadData();
            var dataArr = utils.formatDate(new Date()).split(' ')[0].split('-');
            this.recordByRealmSeasonForm.realmSeason = (dataArr[0] + dataArr[1]) >> 0;
        },
        methods: {
            getReadData() {
                let self = this;
                confApi.getReadData({
                    token: self.token,
                    tableName: 'origin_realm_season_config'
                }).then(res => {
                    self.originRealmSeasonOptions = res;
                })

                confApi.getReadData({
                    token: self.token,
                    tableName: 'login_info_game'
                }).then(res => {
                    self.loginInfoGameOptions = res;
                })

                confApi.getReadData({
                    token: self.token,
                    tableName: 'monster_config'
                }).then(res => {
                    self.monsterConfig = res;
                })
            },

            getAllChampionRecord() {
                let self = this;
                langConfApi.getAllChampionRecord({
                    token: self.token,
                    allChampionRecordForm: self.allChampionRecordForm
                }).then(res => {
                    self.allChampionRecord = res;
                })
            },

            headerCellStyle({row, column, rowIndex, columnIndex}) {
                if (columnIndex == 0) {
                    return { background: '#FFFF00',color: '#000000',textAlign: 'center',padding: '12px 0',fontSize: '16px'};
                } else if (columnIndex == 1) {
                    return { background: '#F4B084',color: '#000000',textAlign: 'center',padding: '12px 0',fontSize: '16px'};
                } else if (columnIndex == 2) {
                    return { background: '#FFD966',color: '#000000',textAlign: 'center',padding: '12px 0',fontSize: '16px'};
                } else if (columnIndex == 3) {
                    return { background: '#FFE699',color: '#000000',textAlign: 'center',padding: '12px 0',fontSize: '16px'};
                }
            },

            // 获取源初境冠军(新)
            recordByRealmSeason() {
                let self = this;
                self.langSelect = self.$i18n.locale;

                self.allChampionRecord = [];

                self.allChampionRecord1 = [];
                self.allChampionRecord2 = [];
                self.allChampionRecord3 = [];


                self.serverWorldList.forEach(worldItem => {
                    let uri = worldItem.inner_urls.split(';')[0];
                    langConfApi.recordByRealmSeason({
                        token: self.token,
                        recordByRealmSeasonForm: {
                            worldUri: uri,
                            realmSeason: self.recordByRealmSeasonForm.realmSeason
                        }
                    }).then(res => {
                        let records = res.content.records;

                        if (self.championOptionsSelect == 1) {
                            records.forEach(item => {
                                let gameServerType = item.gameServer.split('')[0];
                                if (item.ranking == 70001 && gameServerType == 1) {
                                    let server = item.gameServer>>0;
                                    if (server >= 10078){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                    }
                                } else if (item.ranking == 70001 && gameServerType == 2) {
                                    let server = item.gameServer>>0;
                                    if (server >= 20090){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord2 = self.allChampionRecord2.concat(item);
                                    }
                                }else if (item.ranking == 70001){
                                   self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                }
                            })
                        } else if (self.championOptionsSelect == 2) {
                            records.forEach(item => {
                                let gameServerType = item.gameServer.split('')[0];
                                if ((item.ranking == 70001 || item.ranking == 60001 || item.ranking == 60002 || item.ranking == 50001 || item.ranking == 50002 || item.ranking == 50003 || item.ranking == 50004) && gameServerType == 1) {
                                    let server = item.gameServer>>0;
                                    if (server >= 10078){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                    }
                                } else if ((item.ranking == 70001 || item.ranking == 60001 || item.ranking == 60002 || item.ranking == 50001 || item.ranking == 50002 || item.ranking == 50003 || item.ranking == 50004) && gameServerType == 2) {
                                    let server = item.gameServer>>0;
                                    if (server >= 20090){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord2 = self.allChampionRecord2.concat(item);
                                    }
                                }else if (item.ranking == 70001 || item.ranking == 60001 || item.ranking == 60002 || item.ranking == 50001 || item.ranking == 50002 || item.ranking == 50003 || item.ranking == 50004){
                                    self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                }
                            })
                        } else if (self.championOptionsSelect == 3) {
                            records.forEach(item => {
                                let gameServerType = item.gameServer.split('')[0];
                                if ((item.ranking == 70001 || item.ranking == 60001 || item.ranking == 60002 || item.ranking == 50001 || item.ranking == 50002 || item.ranking == 50003 || item.ranking == 50004 || item.ranking == 40001 || item.ranking == 40002 || item.ranking == 40003 || item.ranking == 40004 || item.ranking == 40005 || item.ranking == 40006 || item.ranking == 40007 || item.ranking == 40008) && gameServerType == 1) {
                                    let server = item.gameServer>>0;
                                    if (server >= 10078){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                    }
                                } else if ((item.ranking == 70001 || item.ranking == 60001 || item.ranking == 60002 || item.ranking == 50001 || item.ranking == 50002 || item.ranking == 50003 || item.ranking == 50004 || item.ranking == 40001 || item.ranking == 40002 || item.ranking == 40003 || item.ranking == 40004 || item.ranking == 40005 || item.ranking == 40006 || item.ranking == 40007 || item.ranking == 40008) && gameServerType == 2) {
                                    let server = item.gameServer>>0;
                                    if (server >= 20090){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord2 = self.allChampionRecord2.concat(item);
                                    }
                                } else if (item.ranking == 70001 || item.ranking == 60001 || item.ranking == 60002 || item.ranking == 50001 || item.ranking == 50002 || item.ranking == 50003 || item.ranking == 50004 || item.ranking == 40001 || item.ranking == 40002 || item.ranking == 40003 || item.ranking == 40004 || item.ranking == 40005 || item.ranking == 40006 || item.ranking == 40007 || item.ranking == 40008){
                                    self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                }
                            })
                        } else {
                            records.forEach(item => {
                                let gameServerType = item.gameServer.split('')[0];
                                if (gameServerType == 1) {
                                    let server = item.gameServer>>0;
                                    if (server >= 10078){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                    }
                                } else if (gameServerType == 2) {
                                    let server = item.gameServer>>0;
                                    if (server >= 20090){
                                        self.allChampionRecord3 = self.allChampionRecord3.concat(item);
                                    }else{
                                        self.allChampionRecord2 = self.allChampionRecord2.concat(item);
                                    }
                                }else{
                                    self.allChampionRecord1 = self.allChampionRecord1.concat(item);
                                }
                            })
                        }
                    })
                })
            },
            sortRecords(){
                let self = this;
                self.allChampionRecord1.sort(function(record1, record2) {
                    if (record1.worldServer == record2.worldServer){
                        let ranking1 = record1.ranking >>0;
                        let ranking2 = record2.ranking >>0;
                        return ranking2 - ranking1;
                    }else{
                        let server1 = record1.worldServer.split('w')[1] >>0;
                        let server2 = record2.worldServer.split('w')[1] >>0;
                        return server1 - server2;
                    }
                })
                self.allChampionRecord2.sort(function(record1, record2) {
                    if (record1.worldServer == record2.worldServer){
                        let ranking1 = record1.ranking >>0;
                        let ranking2 = record2.ranking >>0;
                        return ranking2 - ranking1;
                    }else{
                        let server1 = record1.worldServer.split('w')[1] >>0;
                        let server2 = record2.worldServer.split('w')[1] >>0;
                        return server1 - server2;
                    }
                })
                self.allChampionRecord3.sort(function(record1, record2) {
                    if (record1.worldServer == record2.worldServer){
                        let ranking1 = record1.ranking >>0;
                        let ranking2 = record2.ranking >>0;
                        return ranking2 - ranking1;
                    }else{
                        let server1 = record1.worldServer.split('w')[1] >>0;
                        let server2 = record2.worldServer.split('w')[1] >>0;
                        return server1 - server2;
                    }
                })
            },

            getTextWidth(str) {
                let width = 0;
                const html = document.createElement("span");
                html.innerText = str;
                html.className = "getTextWidth";
                document.querySelector("body").appendChild(html);
                // width = document.querySelector(".getTextWidth").offsetWidth * 1.2;
                width = document.querySelector(".getTextWidth").offsetWidth * 1.6;
                document.querySelector(".getTextWidth").remove();
                return width;
            },
            // 动态计算列宽
            flexColumnWidth(label, prop, data) {
                // 将表头加入数组
                const arr = data.map((x) => x[prop]);
                arr.push(label);
                // 计算每列内容最大的宽度
                const maxWidth = arr.reduce((acc, item) => {
                    if (item) {
                        const width = this.getTextWidth(item);
                        acc = Math.max(acc, width);
                    }
                    return acc;
                }, 0);
                // 返回最大宽度加上额外的内间距
                return maxWidth + 25 + "px";
            },
        }
    }
</script>

<style lang="less">
    .origin-realm-champion {
        .el-table tbody tr:hover>td {
            background-color:unset !important;
        }
    }
</style>

<style scoped lang="less">
    .table-champion-record {
        margin:20px 0;
        width: 100%;
    }

    .nick-text {
        font-size: 14px;
    }

    .img-container {
        position: relative;
        width: 104px;
        height: 96px;
        /*margin: 0 10px;*/
        display: flex;
        justify-content: center;

        .prop-img {
            width: 60px;
            height: 60px;
            position: absolute;
            /*top: 2.5px;*/
            /*left: 2.5px;*/
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .prop-img-box {
            width: 76px;
            height: 76px;
            position: absolute;
            /*top: -4px;*/
            /*left: -6px;*/
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .monster-name {
            position: absolute;
            bottom: 0;
            font-weight: bold;
        }
    }

    .champion-img {
        width: 72px;
        height: 44.8px;
    }

    .champion-img-en {
        width: 81.6px;
        height: 44.8px;
    }


</style>



// WEBPACK FOOTER //
// src/views/maintenance/origin_realm_champion.vue